import React from "react";

import { Avatar, CardHeader } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VolumeOffIcon from "@material-ui/icons/VolumeOff";

import { i18n } from "../../translate/i18n";
import formatContactDisplayName from "../../utils/formatContactDisplayName";
import useWhatsApps from "../../hooks/useWhatsApps";
import { isTicketMuted } from "../../utils/ticketMute";

const useStyles = makeStyles(theme => ({
	header: {
		minWidth: 0,
		flex: 1,
	},

	title: {
		color: theme.palette.text.primary,
		fontWeight: 600,
	},

	subheader: {
		color: theme.palette.text.secondary,
		display: "flex",
		alignItems: "center",
		gap: 8,
	},

	internalBadge: {
		display: "inline-block",
		fontSize: 10,
		fontWeight: 700,
		padding: "2px 7px",
		borderRadius: 10,
		backgroundColor: "rgba(254, 74, 35, 0.12)",
		color: "#fe4a23",
		letterSpacing: "0.4px",
		textTransform: "uppercase",
	},

	mutedBadge: {
		display: "inline-flex",
		alignItems: "center",
		gap: 3,
		fontSize: 10,
		fontWeight: 700,
		padding: "2px 7px",
		borderRadius: 10,
		backgroundColor: theme.palette.type === "dark"
			? "rgba(255, 193, 7, 0.16)"
			: "rgba(117, 117, 117, 0.12)",
		color: theme.palette.type === "dark" ? "#ffd54f" : theme.palette.text.secondary,
		textTransform: "uppercase",
	},

	mutedIcon: {
		fontSize: 13,
	},
}));

const TicketInfo = ({ contact, ticket, internalLabel, onClick }) => {
	const classes = useStyles();
	const contactDisplayName = formatContactDisplayName(contact);
	const { whatsApps } = useWhatsApps();
	const isInternalConversation = Boolean(
		contact?.number &&
			(whatsApps || []).some(w => w && w.phoneNumber === contact.number)
	);

	const assignedLine = ticket.user
		? `${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
		: null;
	const muted = isTicketMuted(ticket);

	const subheader = assignedLine || isInternalConversation || muted ? (
		<span className={classes.subheader}>
			{assignedLine && <span>{assignedLine}</span>}
			{isInternalConversation && (
				<span className={classes.internalBadge}>
					{i18n.t("ticketsList.internalTag")}
				</span>
			)}
			{muted && (
				<span className={classes.mutedBadge} title={i18n.t("ticketMute.muted")}>
					<VolumeOffIcon className={classes.mutedIcon} />
					{i18n.t("ticketMute.muted")}
				</span>
			)}
		</span>
	) : null;

	return (
		<CardHeader
			onClick={onClick}
			className={classes.header}
			style={{ cursor: "pointer" }}
			titleTypographyProps={{ noWrap: true, className: classes.title }}
			subheaderTypographyProps={{ noWrap: true, className: classes.subheader }}
			avatar={<Avatar src={contact.profilePicUrl} alt="contact_image" />}
			title={
				internalLabel
					? `${internalLabel} · Conversación interna`
					: `${contactDisplayName} #${ticket.id}`
			}
			subheader={subheader}
		/>
	);
};

export default TicketInfo;
